module.exports = __webpack_public_path__ + "images/sad-outline18adaf34d327553d755bf61b2d152af8.svg";